/*
 * submitbutton creates the window functions enableSubmitButton and disableSubmitButton
 * Helps in avoiding multiple submits / orders by disabling the button and viusalizing
 * that the user's click has triggered the submit.
 *
 * - settings
 * - submitButtonIsDisabled
 * - disableSubmitButton
 * - enableSubmitButton
 */

const SETTINGS = {
  submitButtonSelector: 'button.button',
  submittingClass: 'is-submitting',
  disabledSubmitButtonSelector: 'button.button:disabled',
};

/**
 * submitButtonIsDisables
 *
 * Returns true if the submitButton is disabled,
 * Returns false if the submitButton is not disabled.
 */
export function submitButtonIsDisabled() {
  return $(SETTINGS.disabledSubmitButtonSelector).length > 0;
}

/**
 * disableSubmitButton
 *
 * Disables the submitButton.
 */
export function disableSubmitButton() {
  const { submitButtonSelector, submittingClass } = SETTINGS;
  const submitButton = $(submitButtonSelector);

  if (submitButton.length === 0) return;

  submitButton.addClass(submittingClass);
  submitButton.attr('disabled', 'disabled');
}

/**
 * disableSubmitButton
 *
 * Enables the submitButton.
 */
export function enableSubmitButton() {
  const { submitButtonSelector, submittingClass } = SETTINGS;
  const submitButton = $(submitButtonSelector);

  if (submitButton.length === 0) return;

  submitButton.removeClass(submittingClass);
  submitButton.attr('disabled', false);
}

export default {
  submitButtonIsDisabled,
  disableSubmitButton,
  enableSubmitButton,
};
